import React from "react";
import {Space} from 'antd';
import cx from 'classnames';
import {TExamDetailFixedDataType} from "@/types";
import styles from './ejc_blocks.module.less';
import jobStyles from './styles.module.less';

/**
 * 企业联合认证（EJC）专属区块：考核范围与达标要求 + 认证体系。
 * 仅当静态数据带有 ejc_themes / ejc_levels 时渲染（FCA/FCP 页面不受影响）。
 */
const EjcBlocks: React.FC<{ data: TExamDetailFixedDataType }> = ({data}) => {
  const {ejc_themes, ejc_note, ejc_levels, ejc_levels_note} = data;
  if (!ejc_themes && !ejc_levels) {
    return null;
  }
  return (
    <>
      {ejc_themes && (
        <div className={jobStyles.item}>
          <Space className={jobStyles.icon_wrapper}>
            <img src="/img/detail/detail_icon3.png" className={jobStyles.icon} alt=""/>
            <span className={jobStyles.job_subtitle}>考核范围与达标要求</span>
          </Space>
          <div className={cx(jobStyles.job_text_offset, styles.themes_wrapper)}>
            {ejc_themes.map((theme) => (
              <div key={theme.title} className={styles.theme}>
                <div className={cx(jobStyles.job_subtitle, styles.theme_title)}>
                  <i className={styles.dot} style={{background: theme.color}}/>
                  {theme.title}
                  <span className={styles.pct}>{theme.pct}</span>
                  <span className={styles.mark}>{theme.mark}</span>
                </div>
                <p className={jobStyles.job_text} dangerouslySetInnerHTML={{__html: theme.scope}}/>
                <p className={jobStyles.job_text} dangerouslySetInnerHTML={{__html: theme.standard}}/>
              </div>
            ))}
            {ejc_note && <div className={cx(jobStyles.job_text, styles.note)}
                               dangerouslySetInnerHTML={{__html: ejc_note}}/>}
          </div>
        </div>
      )}
      {ejc_levels && (
        <div className={jobStyles.item}>
          <Space className={jobStyles.icon_wrapper}>
            <img src="/img/detail/detail_icon2.png" className={jobStyles.icon} alt=""/>
            <span className={jobStyles.job_subtitle}>认证体系</span>
          </Space>
          <div className={jobStyles.job_text_offset}>
            <div className={styles.levels}>
              {ejc_levels.map((level) => (
                <div key={level.lv} className={cx(styles.level, level.on && styles.on)}>
                  <span className={styles.lv}>{level.lv}</span>
                  <div className={cx(jobStyles.job_subtitle, styles.lv_name)}>{level.name}</div>
                  <p className={jobStyles.job_text}>{level.desc}</p>
                </div>
              ))}
            </div>
            {ejc_levels_note && <p className={cx(jobStyles.job_text, styles.lv_note)}>{ejc_levels_note}</p>}
          </div>
        </div>
      )}
    </>
  );
};

export default EjcBlocks;
